import { defineField, defineType } from "sanity";

export const lessonContentType = defineType({
  type: "document",
  name: "lessonContent",
  title: "Lesson Content",
  fields: [
    defineField({
      name: "name",
      type: "string",
      title: "Name",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "identifier",
      type: "string",
      title: "Identifier"
    }),
    defineField({
      name: "items",
      type: "array",
      of: [{ type: "reference", to: [{ type: "educationalContent" }] }],
      title: "Items",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "language",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required()
    })
  ],
  preview: {
    select: {
      name: "name",
      slug: "identifier"
    },

    prepare(selection) {
      const { name, slug = "" } = selection;
      return {
        title: name,
        subtitle: slug ? `[.${slug}]` : ""
      };
    }
  }
});
